export class ClientTelephone {
    public id: number;
    public ddd: string;
    public number: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/models/client-telephone.ts